export default {
	gridactions: [],
	formactions: []
};
